const PARAM = 'returnTo'

/** 앱 내부 경로만 허용한다 — `//evil.com`·`http://…` 같은 오픈 리다이렉트를 막는다. */
export function sanitizeReturnTo(raw: string | null | undefined): string | null {
  if (!raw) return null
  if (!raw.startsWith('/')) return null
  if (raw.startsWith('//')) return null
  if (raw.startsWith('/login')) return null
  return raw
}

export function buildLoginPath(currentPath: string): string {
  const safe = sanitizeReturnTo(currentPath)
  return safe ? `/login?${PARAM}=${encodeURIComponent(safe)}` : '/login'
}

export function readReturnTo(search: string): string | null {
  return sanitizeReturnTo(new URLSearchParams(search).get(PARAM))
}

export const RETURN_TO_PARAM = PARAM
